import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';

import { throttlePeriod, colors } from '../../styles/constants';

import { getCircleDimensions } from '../../helpers/circle';

import { default as SingleCircle } from './Circle';
import FooterCircles from './FooterCircles';
import HomeCircles from './HomeCircles';
import ImageCircle from './ImageCircle';
import AboutCircle from './AboutCircle';

const getCircle = (type, image) => {
  switch (type) {
    case 'all':
      return HomeCircles;
    case 'footer':
      return FooterCircles;
    case 'image':
      if (typeof image === 'object') {
        return AboutCircle;
      } else {
        return ImageCircle;
      }
    default:
      return SingleCircle;
  }
};

const DEFAULT_SIZE = 1583;
class Circle extends Component {
  static propTypes = {
    type: PropTypes.string,
    color: PropTypes.string
  };

  static defaultProps = {
    type: 'single'
  };

  constructor(props) {
    super(props);
    this.circleRef = React.createRef();
    this.state = {
      width: null,
      height: null,
      top: 0,
      left: 0
    };
  }

  handleResize = () => {
    const { type: circleType } = this.props;
    const type = circleType === 'image' ? 'single' : circleType; // treat image circle as single circle

    const width = window.innerWidth || document.documentElement.clientWidth;

    const { size, ...position } = getCircleDimensions(width, type);
    if (!size) {
      size = DEFAULT_SIZE;
    }

    // Footer and Single Circle have the same height but differ in width
    // All circles are double the size in width and height
    const widthFactor = type !== 'single' ? 2 : 1;
    const heightFactor = type === 'all' ? 2 : 1;

    this.setState({
      width: Math.round(size * widthFactor),
      height: Math.round(size * heightFactor),
      ...position
    });
  };

  debouncedHandleResize = debounce(this.handleResize, throttlePeriod, {
    leading: false,
    trailing: true
  }).bind(this);

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.debouncedHandleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }

  render() {
    const { type, color, ...props } = this.props;
    const circleColor =
      color && color.startsWith('#') ? color : colors[color] || colors.cyan;
    const Circle = getCircle(type, props.image);
    return <Circle color={circleColor} {...this.state} {...props} />;
  }
}

export default Circle;
